import React from "react";
import ReactHowler from "react-howler";
import { connect } from "react-redux";
import sounds from "../../assets/drift.mp3";
import { getUser } from "./../../lib/session";

const Audio = props => {
  const { type } = getUser() || {};
  const { children, currentlyPlaying } = props;
  const currentMusic =
    currentlyPlaying === false && type === "medical"
      ? sounds
      : currentlyPlaying;
  return (
    <>
      {currentMusic && (
        <ReactHowler src={currentMusic} loop playing={!!currentMusic} />
      )}
      {children}
    </>
  );
};

const mapStateToProps = state => ({
  currentlyPlaying: state.pageReducers.currentlyPlaying
});

export default connect(mapStateToProps)(Audio);
